"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var context_1 = require("../../context");
var utils_1 = require("./utils");
var getSrc = function (sizeObj) {
    return sizeObj.inCache ? sizeObj.cachePath : sizeObj.apiPath;
};
var getSrcSet = function (srcSetPaths) {
    if (srcSetPaths === void 0) { srcSetPaths = []; }
    return srcSetPaths
        .map(function (srcSetPath) { return "".concat(getSrc(srcSetPath), " ").concat(srcSetPath.size, "w"); })
        .join(",");
};
var Image = function (_a) {
    var path = _a.path, size = _a.size, srcSizes = _a.srcSizes, _b = _a.alt, alt = _b === void 0 ? "LMS Image" : _b, _c = _a.format, format = _c === void 0 ? "webp" : _c, props = __rest(_a, ["path", "size", "srcSizes", "alt", "format"]);
    var _d = (0, react_1.useContext)(context_1.EscolaLMSContext), apiUrl = _d.apiUrl, getImagePrefix = _d.getImagePrefix;
    var imgRef = (0, react_1.useRef)(null);
    var imgSize = (0, react_1.useMemo)(function () { return ((srcSizes === null || srcSizes === void 0 ? void 0 : srcSizes[0]) ? srcSizes[0] : size); }, [size, srcSizes]); // can be undefined
    var getSizeObj = (0, react_1.useCallback)(function (size, isDefault) {
        if (isDefault === void 0) { isDefault = false; }
        return ({
            // super important that all param values are strings
            cachePath: (0, utils_1.getImageCachePath)(path, size ? { w: size.toString() } : undefined, getImagePrefix(), format),
            apiPath: (0, utils_1.getImageApiPath)(apiUrl, path, size ? { w: size.toString() } : undefined, format),
            size: size,
            inCache: true,
            isDefault: isDefault,
        });
    }, [apiUrl, path]);
    // array of all sizes
    var _e = (0, react_1.useState)(__spreadArray([
        getSizeObj(imgSize, true)
    ], (srcSizes || []).map(function (ss) { return getSizeObj(ss); }), true)), sizesPaths = _e[0], setSizesPaths = _e[1];
    var src = (0, react_1.useMemo)(function () { return getSrc(sizesPaths.find(function (path) { return path.isDefault; })); }, [sizesPaths]);
    var srcSet = (0, react_1.useMemo)(function () { return getSrcSet(sizesPaths.filter(function (path) { return !path.isDefault; })); }, [sizesPaths]);
    (0, react_1.useLayoutEffect)(function () {
        if (imgRef.current !== null) {
            imgRef.current.onerror = function (error) {
                if (imgRef.current !== null) {
                    var currentSrc_1 = imgRef.current.currentSrc;
                    imgRef.current.onerror = null;
                    // if img is not cached yet, then use generator url
                    if (sizesPaths.some(function (sp) { return sp.cachePath === currentSrc_1; })) {
                        setSizesPaths(sizesPaths.map(function (sizeObj) {
                            if (sizeObj.cachePath !== currentSrc_1)
                                return sizeObj;
                            return __assign(__assign({}, sizeObj), { inCache: false });
                        }));
                    }
                }
            };
        }
    }, []);
    if (path.includes(".svg")) {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "escolalms-image" }, { children: (0, jsx_runtime_1.jsx)("img", __assign({ loading: "lazy", ref: imgRef, src: "".concat(getImagePrefix()).concat(path, "}"), alt: alt }, props)) })));
    }
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "escolalms-image" }, { children: (0, jsx_runtime_1.jsx)("img", __assign({ loading: "lazy", ref: imgRef, src: src, srcSet: srcSet !== "" ? srcSet : undefined, alt: alt }, props)) })));
};
exports.default = Image;
